'use client'

import React, { useState } from 'react'
import Team from './team';
import NextLink from '../individual-components/next-link';
import { TEAMS_LIST } from '@/assets/data/constants';

const TeamSection = () => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const handleSelectSlide = (index) => {
        setCurrentSlide(index);
        setIsDropdownOpen(false);
    };

    const toggleDropdown = () => {
        setIsDropdownOpen(prev => !prev);
    };

    return (
        <div className="w-full max-w-6xl mx-auto">
            <div className="mx-auto">
                <div className="flex w-full flex-wrap justify-center items-center gap-3 leading-10 text-center font-bold text-4xl mb-5 text-[#35343A] z-20">
                    <div className="w-fit font-bold">Build Your</div>
                    <div className="relative select-none w-fit z-20 mr-[22px] after:transition-all after:duration-300 after:absolute after:-bottom-1 after:h-[1px] after:left-0 after:w-full after:bg-gradient-to-r after:from-[#F8C3B7] after:to-[#EB532E]">
                        <input className="hidden peer" type="checkbox" id="select-team" checked={isDropdownOpen} onChange={toggleDropdown} />
                        <label className="relative font-bold cursor-pointer w-fit peer-checked:text-[#EB532E] transition-all duration-200" htmlFor="select-team" id="selected-team">
                            {TEAMS_LIST?.find(e => e?.id === currentSlide + 1)?.label}
                        </label>
                        <label aria-label='select-team' htmlFor="select-team" className="w-0.5 cursor-pointer h-3 absolute top-1/2 transition-all -translate-y-1/2 -right-5 bg-black peer-checked:bg-[#EB532E] duration-200 rotate-45 peer-checked:-rotate-45"></label>
                        <label aria-label='select-team' htmlFor="select-team" className="w-0.5 cursor-pointer h-3 absolute top-1/2 transition-all -translate-y-1/2 -right-[13px] bg-black peer-checked:bg-[#EB532E] duration-200 -rotate-45 peer-checked:rotate-45"></label>
                        <div className={`absolute left-1/2 -translate-x-1/2 p-0 m-0 overflow-hidden transition-all duration-300 top-14 ${isDropdownOpen ? 'max-h-screen' : 'max-h-0'}`}>
                            <div className="relative flex flex-wrap gap-4 w-full px-8 py-6 text-left bg-white rounded-2xl border">
                                {TEAMS_LIST?.map((item, index) => (
                                    <button
                                        key={item.id}
                                        className="text-xl w-full flex py-2 hover:underline cursor-pointer team-option"
                                        onClick={() => handleSelectSlide(index)}
                                    >
                                        {item.label}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="w-fit font-bold">Team</div>
                </div>
                <Team
                    currentSlide={currentSlide}
                    items={TEAMS_LIST}
                />
                <div className='flex justify-center my-10 mt-0'>
                    <NextLink
                        label='Get Started'
                        href='/hiretalent'
                    />
                </div>
            </div>
        </div>
    );
}

export default TeamSection;
